/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanDetailsData {
    getFixupPrototypeFunction() { return SavingsPlanDetailsData.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanDetailsData>): SavingsPlanDetailsData {
        let obj = Object.assign(new SavingsPlanDetailsData(), model);
        SavingsPlanDetailsData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanDetailsData>): SavingsPlanDetailsData {
        if (!model) return null;
        return SavingsPlanDetailsData.newInstance(<SavingsPlanDetailsData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanDetailsData) {
        if (!obj) return;

        models.SavingsPlanDetailsData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanDetailsData): boolean {
        Object.setPrototypeOf(obj, SavingsPlanDetailsData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.SavingsPlanItem.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.SavingsPlanItem>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
